module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-covid-19 ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_vm._m(0)]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("COVID-19 Forms")]), _c('div', [_c('a', {
    staticClass: "covid__form",
    attrs: {
      "href": "https://www.orthoii-forms.com/COVID19InformedConsent.aspx?culture=en-US&custid=3225",
      "target": "_blank"
    }
  }, [_vm._v("COVID-19 Informed Consent Form")])]), _c('div', [_c('a', {
    staticClass: "covid__form",
    attrs: {
      "href": "https://www.orthoii-forms.com/SupplementalHealthQuestionnaire.aspx?culture=en-US&custid=3225",
      "target": "_blank"
    }
  }, [_vm._v("COVID-19 Health Screening Form "), _c('strong', [_vm._v("(please complete on the day of your appointment)")])])]), _c('h2', [_vm._v("Changes to Office Visits During COVID-19")]), _c('div', {
    staticClass: "covid__container"
  }, [_c('div', {
    staticClass: "covid__section"
  }, [_c('h3', [_vm._v("Remote Sign-In")]), _c('ul', [_c('li', [_vm._v("Call us at"), _c('a', {
    attrs: {
      "href": "tel:+19498709713"
    }
  }, [_vm._v(" (949) 870-9713")]), _vm._v(" when you arrive for your appointment. Please wait in your vehicle.")]), _c('li', [_vm._v("The front desk will direct you to our"), _c('a', {
    attrs: {
      "href": "https://www.orthoii-forms.com/SupplementalHealthQuestionnaire.aspx?culture=en-US&custid=3225",
      "target": "_blank"
    }
  }), _vm._v(" COVID-19 Screening Form")]), _c('li', [_vm._v("Our front desk will call you when we are ready for you to come inside. PLEASE SEND ONLY THE PATIENT INTO THE BUILDING.")]), _c('li', [_vm._v("All patients MUST wear a mask when coming in to the office.")]), _c('li', [_vm._v("Parents of unaccompanied minors will be given a verbal 'report card' with details about the visit and their next appointment.")])])]), _c('div', {
    staticClass: "covid__section"
  }, [_c('h3', [_vm._v("Scheduling and Payments")]), _c('ul', [_c('li', [_vm._v("Please CALL the office to \u2028schedule your next appointment.")]), _c('li', [_vm._v("Please make sure your account balance is taken care of before coming to the appointment. Receipts will be emailed.")]), _c('li', [_vm._v("If you need to make a cash payment, please call ahead to make arrangements with the front desk.")]), _c('li', [_vm._v("Forms can be completed online. Most are available on our website at"), _c('a', {
    attrs: {
      "href": "https://updikeortho.com"
    }
  }, [_vm._v(" https://updikeortho.com")])])])]), _c('div', {
    staticClass: "covid__section"
  }, [_c('h3', [_vm._v("Stay home if...")]), _c('ul', [_c('li', [_vm._v("The patient is feeling sick.")]), _c('li', [_vm._v("The patient has a fever.")]), _c('li', [_vm._v("The patient or driver has a sick family member at home.")])])]), _c('div', {
    staticClass: "covid__section"
  }, [_c('h3', [_vm._v("Special Considerations")]), _c('ul', [_c('li', [_vm._v("We understand that there may be certain situations that require exceptions to these new procedures. Please CALL our office"), _c('a', {
    attrs: {
      "href": "tel:+19498709713"
    }
  }, [_vm._v(" (949) 870-9713")]), _vm._v(" to make arrangements.")]), _c('li', [_vm._v("We have also updated our office protocols during the pandemic. Please check out our blog at "), _c('a', {
    attrs: {
      "href": "https://updikeortho.com/blog/covid-19-office-visit-changes"
    }
  }, [_vm._v(" https://updikeortho.com/blog/covid-19-office-visit-changes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22ecec6e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/covid-19/covid-19.pug
// module id = 546
// module chunks = 1